import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick } from 'vue';
import SInfoblock from '@slg/web-customer-shared/src/components/common/SInfoblock.vue';
import {
  isNightCardFieldInvalid,
  resolveDisclaimerMessage,
  resolveFieldErrorMessage,
} from '@/utils/nightCardCheckoutLogic';
import { useI18n, useVm, useValidationError } from '@/composables';


const __default__ = {
  name: 'AnotherPassengerMainNightCard',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  card: {
    type: Object,
    required: true,
  },
  duplicateCards: {
    type: Array,
    default: () => [],
  },
  validationResult: {
    type: [Object, String],
    default: null,
  },
  showOutOfCommuneDisclaimer: {
    type: Boolean,
    default: false,
  },
},
  emits: ['input', 'blur'],
  setup(__props, { expose, emit }) {

const props = __props;




const { t, i18n } = useI18n();
const vm = useVm();
const { validationErrorResolve } = useValidationError();

const validationRules = computed(() => {
  if (!(props.card as any).value) {
    return {};
  }
  return {
    min: 7,
    max: 10,
    onlyLettersAndNumbers: /^[a-zA-Z0-9]+$/,
    noDuplicateAmongCards: {
      cards: props.duplicateCards,
      cardValue: (props.card as any).value,
    },
  };
});

const disclaimerMessage = computed(() => resolveDisclaimerMessage(
  props.validationResult as any,
  t as any,
  i18n.locale,
));

const backendFieldErrorMessage = computed(() => {
  if (!isNightCardFieldInvalid(props.validationResult as any)) {
    return '';
  }
  return resolveFieldErrorMessage(props.validationResult as any, t as any);
});

function getErrorMessage(frontError: any) {
  if (frontError) {
    return validationErrorResolve(frontError);
  }
  if ((props.card as any).isBackendValid === false) {
    return backendFieldErrorMessage.value;
  }
  return '';
}

function onInput(value: string, valid: boolean) {
  emit('input', value, valid);
}

function onBlur(valid: boolean) {
  emit('blur', valid);
}

function validate() {
  return new Promise((resolve) => {
    nextTick(() => {
      resolve((vm.$refs as any)?.mainNightCard?.validate?.() ?? true);
    });
  });
}

expose({
  validate,
});

return { __sfc: true,props, emit, t, i18n, vm, validationErrorResolve, validationRules, disclaimerMessage, backendFieldErrorMessage, getErrorMessage, onInput, onBlur, validate, SInfoblock }
}

})